module.exports = __webpack_public_path__ + "assets/optionspos.984e2146.svg";